import React from "react"
import Helmet from "react-helmet"
// import seoImage from "../images/seoImage.png"

function SEO({ title }) {
    return (
        <Helmet>
            <meta charSet="utf-8" />
            {/* <!-- Primary Meta Tags --> */}
            <title>{title} | EYIB</title>
            <meta name="description" content="Elliot Young's Internship Blog" />

            {/* <!-- Open Graph / Facebook --> */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://eyib.netlify.com/" />
            <meta property="og:title" content="Elliot Young's Internship Blog" />
            <meta property="og:description" content="Elliot Young's Internship Blog" />
            {/* <meta property="og:image" content={seoImage} /> */}

            {/* <!-- Twitter --> */}
            {/* <meta property="twitter:card" content={seoImage} /> */}
            <meta property="twitter:url" content="https://eyib.netlify.com/" />
            <meta property="twitter:title" content="The Pub, Independent Journal" />
            <meta property="twitter:description" content="Elliot Young's Internship Blog" />
            <meta property="twitter:image" content=""></meta>
        </Helmet>
    )
}

export default SEO